import {
  ITrigger,
  ITriggeredContentByPage,
  TriggerPageShortCodeAndZoneName,
  IPersistedExperience,
  ITriggersByPageUrl,
} from "../types";

interface State {
  triggersByPage: ITriggersByPageUrl | null;
  universalTriggers: ITrigger[];
  currentPageTriggers: ITrigger[];
  triggeredContentByPage: Record<
    string,
    Record<TriggerPageShortCodeAndZoneName, ITriggeredContentByPage>
  >;
  universalTriggeredContent: ITriggeredContentByPage[];
  persistedExperience: IPersistedExperience[];
  isPageHidden: boolean;
  internalSessionId: number | null;
  isPreviewMode: boolean;
  isPreviewZonesMode: boolean;
  previewModeParameters: {
    previewClusterVersionId: number | string | undefined | null;
    previewExperimentVariationId: number | string | undefined | null;
  };
}

export const store = (() => {
  let state: State = {
    triggersByPage: null,
    universalTriggers: [],
    currentPageTriggers: [],
    internalSessionId: null,
    triggeredContentByPage: {},
    universalTriggeredContent: [],
    persistedExperience: [],
    isPageHidden: false,
    isPreviewMode: false,
    isPreviewZonesMode: false,
    previewModeParameters: {
      previewClusterVersionId: undefined,
      previewExperimentVariationId: undefined,
    },
  };

  const set = <T extends keyof State>(key: T, value: State[T]) => {
    state = {
      ...state,
      [key]: value,
    };
  };

  const get = <T extends keyof State>(key: T) => state[key] as State[T];

  return {
    state,
    get,
    set,
  };
})();
